import type { VrdhSchedulingSlot } from '@/api/types/ProviderApi'
import { ButtonText } from '@/ui/core/button'
import { format } from 'date-fns'
import { Pressable } from 'react-native'

export type SlotTimeButtonProps = {
	slot: VrdhSchedulingSlot
	onPressed: (slot: VrdhSchedulingSlot) => void
}

export const SlotTimeButton = ({ slot, onPressed }: SlotTimeButtonProps) => {
	const slotTimeSplit = format(slot.startTimeUtc, 'h:mm a').split(' ')

	return (
		<Pressable
			role="button"
			onPress={() => onPressed(slot)}
			className="flex flex-row gap-1 w-24 pt-1.5 justify-center items-center"
		>
			<ButtonText className="text-center text-lg text-palette_3">
				{slotTimeSplit[0]}
			</ButtonText>
			<ButtonText className="text-center text-palette_3 text-md font-apercu-primary">
				{slotTimeSplit[1]}
			</ButtonText>
		</Pressable>
	)
}
